import TeamHomeTour from './TeamHomeTour';

export default TeamHomeTour